// import React, { useState } from "react";
// import { MenuItem, Select, OutlinedInput } from "@mui/material";
// import {
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   FormControlLabel,
//   Checkbox,
//   Chip,
//   Box,
//   Typography,
//   FormControl,
//   InputLabel,
//   CircularProgress,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// const CategoryClip = ({
//   categories,
//   selectedCategories,
//   setSelectedCategories,
//   fetchSubCategories,
//   selectedSubCategories,
//   setSelectedSubCategories,
// }) => {
//   const handleSelect = event => {
//     const value = event.target.value;
//     if (value.includes("All")) {
//       setSelectedCategories(selectedCategories.length === categories.length ? [] : [...categories]);
//     } else {
//       setSelectedCategories(categories.filter(cat => value.includes(cat.categoryId)));
//     }
//   };

//   const handleDelete = id => {
//     setSelectedCategories(prevSelected => prevSelected.filter(cat => category.categoryId !== id));
//   };

//   const [expandedCategoryId, setExpandedCategoryId] = useState(null);
//   const [loadingCategoryId, setLoadingCategoryId] = useState(null);
//   const [subCatMap, setSubCatMap] = useState({}); // categoryId => subCategories[]

//   const handleAccordionChange = async categoryId => {
//     setExpandedCategoryId(prev => (prev === categoryId ? null : categoryId));

//     if (!subCatMap[categoryId]) {
//       setLoadingCategoryId(categoryId);
//       const subs = await fetchSubCategories(categoryId);
//       setSubCatMap(prev => ({ ...prev, [categoryId]: subs }));
//       setLoadingCategoryId(null);
//     }
//   };

//   const handleSubCatToggle = subCat => {
//     const exists = selectedSubCategories.some(s => s.subCategoryId === subCat.subCategoryId);
//     if (exists) {
//       setSelectedSubCategories(prev => prev.filter(s => s.subCategoryId !== subCat.subCategoryId));
//     } else {
//       setSelectedSubCategories(prev => [...prev, subCat]);
//     }
//   };

//   const handleChipDelete = id => {
//     setSelectedSubCategories(prev => prev.filter(s => s.subCategoryId !== id));
//   };

//   const isChecked = subCatId => selectedSubCategories.some(s => s.subCategoryId === subCatId);

//   return (
//     <FormControl fullWidth className='select-category'>
//       <InputLabel className='select-category-lable'>Product Category *</InputLabel>
//       <Select
//         multiple

//         // required
//         value={selectedCategories?.map(cat => cat.categoryId)} // Store only IDs in Select
//         onChange={handleSelect}
//         input={<OutlinedInput label='Product Category *' />}
//         className='category-box'
//         // renderValue={(selected) => (
//         //   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//         //     {selectedCategories.map((cat) => (
//         //       <Chip key={category.id} label={category.name} onDelete={() => handleDelete(category.id)} />
//         //     ))}
//         //   </Box>
//         // )}
//       >
//         {/* Select All Option */}
//         <MenuItem value='All'>
//           {selectedCategories?.length === categories.length ? "Deselect All" : "Select All"}
//         </MenuItem>

//         {/* Individual Category Options */}
//         {categories?.map(category => (
//           <MenuItem
//             key={category.categoryId}
//             value={category.categoryId}
//             onClick={() => handleAccordionChange(category.categoryId)}
//           >
//             <Accordion
//               key={category.categoryId}
//               style={{width: '100%'}}
//               expanded={expandedCategoryId === category.categoryId}
//               onChange={() => handleAccordionChange(category.categoryId)}
//             >
//               <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                 <Typography>{category.name}</Typography>
//               </AccordionSummary>
//               <AccordionDetails>
//                 {loadingCategoryId === category.categoryId ? (
//                   <CircularProgress size={24} />
//                 ) : selectedSubCategories?.length > 0 ? (
//                   selectedSubCategories.map(sub => (
//                     <FormControlLabel
//                       key={sub.subCategoryId}
//                       control={
//                         <Checkbox
//                           checked={isChecked(sub.subCategoryId)}
//                           onChange={() => handleSubCatToggle(sub)}
//                         />
//                       }
//                       label={sub.name}
//                     />
//                   ))
//                 ) : (
//                   <Typography variant='body2' color='text.secondary'>
//                     No subcategories
//                   </Typography>
//                 )}
//               </AccordionDetails>
//             </Accordion>
//           </MenuItem>
//         ))}
//         {/* {selectedSubCategories?.map(category => (
//           <MenuItem key={category.categoryId} value={category.categoryId}>
//             {category.name}
//           </MenuItem>
//         ))} */}
//       </Select>

//       {/* Show selected categories as removable MUI Chips below the dropdown */}
//       {/* <Box mt={2} sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//         {selectedCategories.map(cat => (
//           <Chip
//             key={category.categoryId}
//             label={category.nameEn}
//             style={{ borderRadius: "6px" }}
//             onDelete={() => handleDelete(category.categoryId)}
//           />
//         ))}
//       </Box> */}
//       {selectedSubCategories.length > 0 && (
//         <Box mt={2} sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//           {selectedSubCategories?.map(sub => (
//             <Chip
//               key={sub.subCategoryId}
//               label={sub.name}
//               onDelete={() => handleChipDelete(sub.subCategoryId)}
//               style={{ borderRadius: "6px" }}
//             />
//           ))}
//         </Box>
//       )}
//     </FormControl>
//   );
// };

// export default CategoryClip;

import React, { useState } from "react";
import {
  MenuItem,
  Select,
  OutlinedInput,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  Checkbox,
  Chip,
  Box,
  Typography,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CategoryClip = ({
  categories,
  selectedCategories,
  fetchSubCategories,
  selectedSubCategories,
  setSelectedSubCategories,
}) => {
  const [expandedCategoryId, setExpandedCategoryId] = useState(null);
  const [loadingCategoryId, setLoadingCategoryId] = useState(null);
  const [subCatMap, setSubCatMap] = useState({}); // categoryId => subCategories[]

  const handleSelect = event => {
    const value = event.target.value;
  };

  const handleAccordionChange = async categoryId => {
    setExpandedCategoryId(prev => (prev === categoryId ? null : categoryId));
    if (!subCatMap[categoryId]) {
      setLoadingCategoryId(categoryId);
      const subs = await fetchSubCategories(categoryId);
      setSubCatMap(prev => ({ ...prev, [categoryId]: subs }));
      setLoadingCategoryId(null);
    }
  };

  const handleSubCatToggle = subCat => {
    const exists = selectedSubCategories.some(s => s.subCategoryId === subCat.subCategoryId);
    if (exists) {
      setSelectedSubCategories(prev => prev.filter(s => s.subCategoryId !== subCat.subCategoryId));
    } else {
      setSelectedSubCategories(prev => [...prev, subCat]);
    }
  };

  const handleChipDelete = id => {
    setSelectedSubCategories(prev => prev.filter(s => s.subCategoryId !== id));
  };

  const isChecked = subCatId => selectedSubCategories.some(s => s.subCategoryId === subCatId);
  return (
    <FormControl fullWidth className='select-category'>
      <InputLabel className='select-category-lable'>Product Category *</InputLabel>
      <Select
        multiple
        value={selectedCategories?.map(cat => cat.categoryId)}
        onChange={handleSelect}
        input={<OutlinedInput label='Product Category *' />}
        className='category-box'
      >
        {categories?.map(category => (
          <MenuItem key={category.categoryId} value={category.categoryId} style={{ padding: 0 }}>
            <Accordion
              style={{ width: "100%" }}
              expanded={expandedCategoryId === category.categoryId}
              onChange={() => handleAccordionChange(category.categoryId)}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography style={{ fontSize: "16px", color: "#495057" }}>
                  {category.name}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {loadingCategoryId === category.categoryId ? (
                  <CircularProgress size={20} />
                ) : subCatMap[category.categoryId]?.length > 0 ? (
                  subCatMap[category.categoryId].map(sub => (
                    <FormControlLabel
                      key={sub.subCategoryId}
                      control={
                        <Checkbox
                          checked={isChecked(sub.subCategoryId)}
                          onChange={() => handleSubCatToggle(sub)}
                        />
                      }
                      label={sub.name}
                    />
                  ))
                ) : (
                  <Typography variant='body2' color='text.secondary'>
                    No subcategories
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
          </MenuItem>
        ))}
      </Select>

      {/* Show selected subcategories as chips */}
      {selectedSubCategories.length > 0 && (
        <Box mt={2} sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {selectedSubCategories?.map(sub => (
            <Chip
              key={sub.subCategoryId}
              label={sub.name}
              onDelete={() => handleChipDelete(sub.subCategoryId)}
              style={{ borderRadius: "6px" }}
            />
          ))}
        </Box>
      )}
    </FormControl>
  );
};

export default CategoryClip;
